<template>
  <div>
    <router-view />

    <wallet-board :chains="computedChains" @wallets="getWallets" @disconnected="disconnected" />
  </div>
</template>

<script>
import WalletBoard from '@/WalletBoard'

import { mapState, mapActions } from 'vuex'

import { getSupportNetwork } from '@/constants'
import { ethers } from 'ethers'
import { DEFAULT_ADDRESS } from './constants'
import { getLocalStorage, getParameterByName, Last_Net, setLocalStorage } from './utils'
import { WalletBoardBus } from './WalletBoard.vue'
import axios from 'axios'

export default {
  name: 'App',
  components: {
    WalletBoard,
  },
  data() {
    return {
      timer: null,
    }
  },
  computed: {
    ...mapState('wallet', ['sumer', 'isWalletReset', 'chainId', 'account']),
    ...mapState('tx', ['txHashs']),
    ...mapState('loading', ['systemLoading']),

    isTx() {
      if (this.systemLoading) {
        return true
      }

      if (this.isWalletReset) {
        return true
      }

      let b = false
      for (const item of Object.keys(this.txHashs)) {
        if (this.txHashs[item] !== '') {
          b = true
          break
        }
        b = false
      }
      return b
    },
    computedChains() {
      return getSupportNetwork().map((net) => {
        return {
          id: `0x${Number(net.networkId).toString(16)}`,
          token: net.symbol,
          label: net.name,
          rpcUrl: net.rpc,
          publicRpcUrl: net.rpc,
          blockExplorerUrl: net.blockExplorer,
        }
      })
    },
  },
  watch: {
    account(val) {
      this.getLayerzeroMsg()
    },
    chainId(val) {
      const net = getSupportNetwork().find((net) => net.networkId === Number(val))
      if (net) {
        // setLocalStorage(Last_Net, val)

        const { chain } = this.$route.query
        // console.log('chainId change', val)
        if (!chain || Number(chain) != val) {
          if (this.$route.name) {
            this.$router.replace({
              path: this.$route.path,
              query: { ...this.$route.query, chain: this.chainId },
            })
          }
        }
      }

      // if core net then go bridge page
      // if (val === 1116) {
      //   this.$router.push({ name: 'Bridge' })
      // }
    },
    '$route.name'(r) {
      // console.log('$route.name change', r)
      const { chain } = this.$route.query
      if (this.chainId && this.chainId != chain) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, chain: this.chainId },
        })
      }
    },
    // "$route.query"(q) {
    //   // console.log('$route.query', q)
    //   if (q.chain && q.chain != this.chainId && this.account !== DEFAULT_ADDRESS) {
    //     // setLocalStorage(Last_Net, Number(q.chain))
    //     this.useDefaultNet(Number(q.chain))
    //   }
    // },
    // account(acc) {
    //   if (acc !== DEFAULT_ADDRESS) {
    //     const net = getLocalStorage(Last_Net)
    //     if (net && Number(net) !== this.chainId) {
    //       WalletBoardBus.$emit('setChain', Number(net))

    //       setLocalStorage(Last_Net, this.chainId)
    //     }
    //   }
    // }
  },
  async created() {
    // const chain = getParameterByName('chain')
    // let networkId = 1
    // if (chain && getSupportNetwork().find((net) => net.networkId === Number(chain))) {
    //   networkId = Number(chain)
    // }
    // this.useDefaultNet(networkId)
    // const test1234 = await axios.get('https://scan-testnet.layerzero-api.com/v1/messages/wallet/0x57e7e16A2326DC41d02402103A73b4464A8B3EEb?limit=1')
    // console.log('test1234', test1234.data.data)
  },
  methods: {
    ...mapActions({
      initWallet: 'wallet/initWallet',
      getLayerzeroMsg: 'message/getLayerzeroMessage',
    }),
    loopInitData() {
      this.timer = setTimeout(() => {
        this.initData()
      }, 1000 * 60)
    },
    pauseLoopInitData() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    getWallets(wallets) {
      console.log('CALLED GET WALLETS')
      const { accounts, chains, provider, icon, label } = wallets[0]

      const chainId = Number(chains[0].id)

      // const currentNetwork = getSupportNetwork().find((net) => net.networkId === chainId)
      console.log('called init wallet 2')
      this.initWallet({ accounts: accounts, chainId, provider, icon })

      // if (!currentNetwork) {
      //   this.$store.commit('modal/SHOW_CHECK_NETWORK')
      // }
    },
    disconnected() {
      console.log('called init wallet 3')
      this.initWallet({ disconnected: true })
    },
  },
}
</script>

<style lang="scss">
@import './style/_variable';

.v-application {
  // font-family: 'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif;
  // color: $black;
  font-size: $font-sm;
}
.font-size-xs {
  font-size: $font-xs;
}
.font-size-sm {
  font-size: $font-sm;
}
.font-size-lg {
  font-size: $font-lg;
}
.text-color-light {
  color: lighten(#716040, 25%);
}
.row + .row {
  margin-top: 12px !important;
}
.text-color {
  color: #716040 !important;
}
.text-error {
  color: #d2463a;
}

.h-100 {
  height: 100%;
}
.cursor-pointer {
  cursor: pointer;
}

:root {
  --onboard-modal-z-index: 999;
  --wcm-z-index: 1000 !important;
}
</style>
